import toastHelper from "../../Util/toastHelper";

import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../API/API";
import axios from "axios";

export const getAllNotifications = createAsyncThunk(
  "notification/getAllNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllNotifications.url,
        method: API.admin.getAllNotifications.method,
      });
      return data?.notifications;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllUserNotifications = createAsyncThunk(
  "notification/getAllUserNotifications",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllUserNotifications.url,
        method: API.admin.getAllUserNotifications.method,
      });
      return data?.notifications;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getNotificationById = createAsyncThunk(
  "notification/getNotificationById",
  async (params: { id: number }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getNotificationById.url + params.id,
        method: API.admin.getNotificationById.method,
      });
      return data?.notification;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const markAsReadNotification = createAsyncThunk(
  "notification/markAsReadNotification",
  async (
    params: { notificationId: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.markAsReadNotification.url,
        method: API.admin.markAsReadNotification.method,
        data: params,
      });
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteNotificationById = createAsyncThunk(
  "notification/deleteNotificationById",
  async (
    params: { id: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteNotificationById.url + params.id,
        method: API.admin.deleteNotificationById.method,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addNotification = createAsyncThunk(
  "notification/addNotification",
  async (
    params: {
      title: string;
      message: string;
      sendToAll: boolean;
      buildingId: string;
      memberIds: number[];
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addNotification.url,
        method: API.admin.addNotification.method,
        data: params,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const publishNotification = createAsyncThunk(
  "notification/publishNotification",
  async (
    params: {
      notificationId: number;
      messageSent: boolean;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.publishNotification.url,
        method: API.admin.publishNotification.method,
        data: params,
      });
      params?.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateNotification = createAsyncThunk(
  "notification/updateNotification",
  async (
    params: {
      notificationId: number;
      title: string;
      message: string;
      sendToAll: boolean;
      buildingId: string;
      memberIds: number[];
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateNotification.url,
        method: API.admin.updateNotification.method,
        data: params,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
